import { hideCursors, unhideCursors } from "../helpers-board.js";

function invertedCursor({ board, buttons, registerCleanup }) {
  // setupShadowGrid();
  document.documentElement.style.cursor = 'none';
  let cursor = board.querySelector('.customCursor');
  if (!cursor) {
    cursor = board.appendChild(document.createElement('div'));
    cursor.classList.add('customCursor');
  }
  document.addEventListener('mousemove', (e) => {
    cursor.style.position = 'fixed';
    cursor.style.top = `${window.innerHeight - e.clientY}px`;
    cursor.style.left = `${window.innerWidth - e.clientX}px`;
  })

  hideCursors({ board, buttons });
  registerCleanup(() => {
    unhideCursors({ board });
    document.documentElement.style.cursor = '';
    cursor.remove();
  })
}


export default invertedCursor;

// function setupShadowGrid() {
//   buttons.forEach((btn, i) => {
//     const rect = btn.getBoundingClientRect();
//   });
// }
